<tt-file-uploader ttLabelView="none" (ttFilesChange)="onFilesChanged($event)" ttMultiple="false" ttDropZone></tt-file-uploader>
<div
    [hidden]="!hasSpreadsheet"
    class="flex-1"
    [ngClass]="{ 'tt-spreadsheet__hide-toolbar': ttHideToolbar, 'tt-spreadsheet__hide-actionbar': ttHideActionbar, 'tt-spreadsheet__hide-sheetsbar': ttHideSheetsbar }"
>
    <kendo-spreadsheet class="height-full" (change)="onSpreadsheetChanged($event)" (activeSheetChange)="onSpreadsheetChanged($event)"></kendo-spreadsheet>
</div>
<ng-container *ngIf="!!jsonData">
    <tt-select ttLabelView="top" ttLabel="encoding" [(ttModel)]="selectedEncoding" (ttModelChange)="onEncodingChanged($event)" [ttData]="encodings"></tt-select>
    <tt-textarea style="flex: 1; overflow: auto" ttLabelView="top" class="flex-1" ttLabel="filecontent" [(ttModel)]="jsonData" ttReadonly></tt-textarea>
</ng-container>
<tt-toast *ngIf="!hasSpreadsheet && !jsonData" class="col-xs-6 sp-0" ttTitle="no_file_selected" ttMessage="select_a_file_to_view_data" style="max-width: 40rem; width: 100%"></tt-toast>
